import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ProfileImg from '../ProfileImage/index.js';
import { ProfileWidgetBox, ProfileDataBox } from './shared.js';
import Badge from '../Badge.js';
import { PlayIcon } from '../Icons/index.js';

var _templateObject, _templateObject2, _templateObject3;
var FloatingIcon = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: absolute;\n  right: ", ";\n  bottom: ", ";\n"])), function (_ref) {
  var vertical = _ref.vertical;
  return "".concat(vertical ? "-20" : "-70", "px");
}, function (_ref2) {
  var vertical = _ref2.vertical;
  return "".concat(vertical ? "-70" : "-25", "px");
});
var ProfileImgContainer = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  align-items: flex-start;\n  flex-basis: 50%;\n  @media (min-width: 768px) and (max-width: 991.98px) {\n    ", "\n  }\n"])), function (_ref3) {
  var square = _ref3.square;
  return square && "flex-basis: 25%";
});
var MetaContainer = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  position: relative;\n  width: 100%;\n  ", "\n  div {\n    display: inline-block;\n  }\n"])), function (_ref4) {
  var square = _ref4.square;
  return square && "position: absolute; left: 20px; bottom: 20px;";
});
var ProfileCard = function ProfileCard(_ref5) {
  var src = _ref5.src,
    onPhotoClick = _ref5.onPhotoClick,
    children = _ref5.children,
    vertical = _ref5.vertical,
    badge = _ref5.badge,
    playable = _ref5.playable,
    fluid = _ref5.fluid,
    square = _ref5.square;
  return /*#__PURE__*/React__default.createElement(ProfileWidgetBox, {
    vertical: vertical,
    fluid: fluid
  }, /*#__PURE__*/React__default.createElement(ProfileImgContainer, {
    square: square
  }, /*#__PURE__*/React__default.createElement(ProfileImg, {
    photo: src,
    fluid: fluid,
    square: square,
    onClick: onPhotoClick
  }, /*#__PURE__*/React__default.createElement(MetaContainer, {
    square: square
  }, badge ? /*#__PURE__*/React__default.createElement(Badge, {
    color: badge.color
  }, badge.text) : null, playable ? /*#__PURE__*/React__default.createElement(FloatingIcon, {
    vertical: vertical
  }, /*#__PURE__*/React__default.createElement(PlayIcon, null)) : null))), /*#__PURE__*/React__default.createElement(ProfileDataBox, {
    square: square
  }, children));
};
ProfileCard.displayName = "ProfileCard";
ProfileCard.propTypes = {
  playable: PropTypes.bool,
  fluid: PropTypes.bool,
  vertical: PropTypes.bool,
  src: PropTypes.string,
  onPhotoClick: PropTypes.func,
  badge: PropTypes.shape({
    text: PropTypes.string,
    color: PropTypes.string
  })
};

export { ProfileCard as default };
